<script>
  import { pop } from 'svelte-spa-router';
</script>

<div class="min-h-screen bg-gray-50 dark:bg-gray-950 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8 border border-gray-200 dark:border-gray-700">
    <div class="mb-8 flex items-center justify-between">
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">Terms and Conditions</h1>
      <button 
        on:click={() => window.history.back()} 
        class="text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300 font-medium"
      >
        &larr; Back
      </button>
    </div>

    <div class="prose dark:prose-invert max-w-none text-gray-600 dark:text-gray-300">
      <p>Last updated: December 18, 2025</p>

      <h2>1. Introduction</h2>
      <p>Welcome to Koru. By accessing or using our website and services, you agree to be bound by these Terms and Conditions.</p>

      <h2>2. Use of Service</h2>
      <p>You agree to use our platform only for lawful purposes and in accordance with these Terms. You are responsible for all content you post and activity that occurs under your account.</p>

      <h2>3. Intellectual Property</h2>
      <p>The service and its original content, features, and functionality are and will remain the exclusive property of Koru and its licensors.</p>

      <h2>4. Termination</h2>
      <p>We may terminate or suspend access to our service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>

      <h2>5. Changes</h2>
      <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. What constitutes a material change will be determined at our sole discretion.</p>

      <h2>6. Contact Us</h2>
      <p>If you have any questions about these Terms, please contact us.</p>
    </div>
    
    <div class="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
       <a href="#/" class="text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300 font-medium">Return to Home</a>
    </div>
  </div>
</div>
